// Legal pages live on the marketing site (apps/landing/src/pages). Keep the
// support address in sync with apps/landing/src/lib/legal.ts and the payment
// provider's organization settings.
const SITE = "https://svgmascot.com";

export const legalUrls = {
  terms: `${SITE}/terms`,
  privacy: `${SITE}/privacy`,
  acceptableUse: `${SITE}/acceptable-use`,
  refund: `${SITE}/refund`,
  pricing: `${SITE}/#pricing`,
} as const;

export const SUPPORT_EMAIL = "support@svgmascot.com";
